export default {"src":"/_next/static/media/envelope-regular.ba00e9b2.svg","height":24,"width":24};